<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-dialog>
  <ods-dialog-header heading="Gerät löschen" (closeClicked)="close()" />
  <ods-dialog-content>
    <p data-test-id="delete-device-dialog-text">
      Möchten Sie das Gerät <strong>{{ deviceName() }}</strong> wirklich löschen? Wenn es Ihr letztes Gerät ist, ist Ihr Zugang
      danach nicht mehr durch eine Zwei-Faktor-Authentifizierung geschützt.
    </p>
  </ods-dialog-content>
  <ods-dialog-footer closeButtonText="Abbrechen" (closeClicked)="close()">
    <odc-button-with-spinner
      text="Löschen"
      icon="delete"
      destructive="true"
      dataTestId="delete-device-confirm-button"
      data-test-id="delete-device-confirm-ods-button"
      [stateResource]="stateResource()"
      (clicked)="confirmed.emit()"
    />
  </ods-dialog-footer>
</ods-dialog>
